import type CoachService from '@efdigital/ll-xceed-v2/services/coach';
import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class IndexRoute extends Route {
  @service declare coach: CoachService;
  @service declare coachee: CoacheeService;
  @service declare router: RouterService;

  async afterModel() {
    const isCoach = await this.coach.isCoach();

    if (isCoach) {
      this.router.transitionTo('coaching.coach.index');
    } else {
      const isCoachee = await this.coachee.isCoachee();
      if (isCoachee) {
        this.router.transitionTo('coaching.coachee.index');
      }
    }
  }
}
